import React from 'react';
import { StyleSheet } from 'react-native';
import { Typography, Box } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { strings } from '../../constants';
import OutlineCamera from '../CustomSVGIcons/OutlineCamera';

const EsNoSubmissions = () => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);

    return (
        <Box
            style={styles.flexColumn}
            sx={{
                gap: '12px',
                height: 'fit-content',
                width: '100%',
            }}>
            <OutlineCamera stroke={theme[themeStyle].highlight} />
            <Typography style={styles.text}>{strings.no_submissions}</Typography>
        </Box>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        flexColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        },
        text: {
            fontSize: 14,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_REGULAR,
            textAlign: 'left',
            color: theme[colorScheme].gray_message,
        },
    });

export { EsNoSubmissions };
